<div class="dashboard__stats">
  <div class="l-wrapper">
    <div class="c-booking-stats">
      <div class="c-booking-stats__header">
        <div class="c-booking-stats__info-block">
          <h4 class="t-4 c-booking-stats__title">Tariff</h4>
        </div>
        <button
          class="a-btn a-btn--default c-booking-stats__back-btn"
          (click)="onGoBack()"
        >
          <svg class="a-icon u-mr-xs">
            <use xlink:href="#long-arrow--back"></use>
          </svg>
          Back to home
        </button>
      </div>

      <div>
        <surf-tariff-search-criteria> </surf-tariff-search-criteria>
      </div>
    </div>
  </div>
</div>
<div #tariffTableElement class="dashboard__results" *ngIf="!tariffSearchResultService.initialLoading">
  <div class="l-wrapper dashboard__results-wrapper">
    <!--Tariff results table-->
    <surf-tariff-search-results
    [componentId]="'tariffResults'"
    [resultList]="resultList"
    > </surf-tariff-search-results>
  </div>
</div>
